import { typeBoolean } from '../constants/parameterTypes';
import { paramNoValidate } from '../constants/parameterNames';
import { getBoolParamValue } from "../helpers/parameter.accessors";

const description = "Returns the number of current validation errors in the form.";

const optionalParameters = {
    [paramNoValidate]: {
        description: "(boolean, defaults to false) Prevents this command from re-validating the form's fields.",
        type: typeBoolean,
    },
};

function execute({ parameters, validation }) {
    const noValidate = getBoolParamValue(
        parameters,
        paramNoValidate,
        false,
    );

    return validation.getErrors(!noValidate).length;
}

const GetErrorCount = {
    description,
    optionalParameters,
    execute,
};

export default GetErrorCount;
